import { useMutation, useQuery, useQueryClient } from "react-query";
import qs from "qs-lite";

import api from "../../utils/api";
import { invalidate } from "../../helpers/clientHelper";

const NOTIFICATIONS = "/notifications";
const PREFS = "/notifications/preferences";
const SUBS = "/notifications/subscriptions";

const getNotifications = ({ queryKey }) => {
  const queryString = qs.stringify(queryKey[1]);
  return api.get(`${NOTIFICATIONS}?${queryString}`);
};
export const useGetNotifications = (options = {}) => {
  const { limit = 20, offset = 0, unreadOnly = false } = options;
  return useQuery(
    [NOTIFICATIONS, { limit, offset, unreadOnly }],
    getNotifications,
  );
};

const getUnreadCount = () => api.get(`${NOTIFICATIONS}/unread-count`);
export const useGetUnreadCount = () =>
  useQuery([NOTIFICATIONS, "unread-count"], getUnreadCount);

const putMarkRead = (id) => api.put(`${NOTIFICATIONS}/${id}/read`);
export const usePutMarkRead = () => {
  const queryClient = useQueryClient();
  return useMutation(putMarkRead, {
    onSuccess: () => {
      invalidate(queryClient, NOTIFICATIONS);
    },
  });
};

const putMarkAllRead = () => api.put(`${NOTIFICATIONS}/read-all`);
export const usePutMarkAllRead = () => {
  const queryClient = useQueryClient();
  return useMutation(putMarkAllRead, {
    onSuccess: () => {
      invalidate(queryClient, NOTIFICATIONS);
    },
  });
};

const deleteDismiss = (id) => api.delete(`${NOTIFICATIONS}/${id}`);
export const useDeleteDismiss = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteDismiss, {
    onSuccess: () => {
      invalidate(queryClient, NOTIFICATIONS);
    },
  });
};

const deleteDismissAllRead = () =>
  api.delete(`${NOTIFICATIONS}/dismiss-read`);
export const useDeleteDismissAllRead = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteDismissAllRead, {
    onSuccess: () => {
      invalidate(queryClient, NOTIFICATIONS);
    },
  });
};

const getPreferences = () => api.get(PREFS);
export const useGetPreferences = () => useQuery([PREFS], getPreferences);

const putPreferences = (data) => api.put(PREFS, data);
export const usePutPreferences = () => {
  const queryClient = useQueryClient();
  return useMutation(putPreferences, {
    onSuccess: () => invalidate(queryClient, PREFS),
  });
};

const getSubscriptions = () => api.get(SUBS);
export const useGetSubscriptions = () => useQuery([SUBS], getSubscriptions);

const postSubscription = (data) => api.post(SUBS, data);
export const usePostSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation(postSubscription, {
    onSuccess: () => invalidate(queryClient, SUBS),
  });
};

const deleteSubscription = (id) => api.delete(`${SUBS}/${id}`);
export const useDeleteSubscription = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteSubscription, {
    onSuccess: () => invalidate(queryClient, SUBS),
  });
};

const postTestChat = (data = {}) =>
  api.post(`${NOTIFICATIONS}/test-chat`, data);
export const usePostTestChat = () => useMutation(postTestChat);
